/**
 * Configuration for "fra-til" route landing pages — targets "kurer fra X til Y"
 * Google searches. Each entry: { fromSlug, toSlug, approxKm, priceSameDay }
 *
 * Distance values are based on real OSRM calculations between city centers.
 * priceSameDay = 199 + max(0, km - 8) * 6  (Same-Day with no surcharges)
 */
export const ROUTES = [
  // Existing top 10
  { fromSlug: "koebenhavn", toSlug: "roskilde", approxKm: 33, priceSameDay: 349 },
  { fromSlug: "roskilde", toSlug: "koebenhavn", approxKm: 33, priceSameDay: 349 },
  { fromSlug: "koebenhavn", toSlug: "koege", approxKm: 40, priceSameDay: 391 },
  { fromSlug: "koege", toSlug: "koebenhavn", approxKm: 40, priceSameDay: 391 },
  { fromSlug: "koebenhavn", toSlug: "helsingoer", approxKm: 50, priceSameDay: 451 },
  { fromSlug: "helsingoer", toSlug: "koebenhavn", approxKm: 50, priceSameDay: 451 },
  { fromSlug: "koebenhavn", toSlug: "hilleroed", approxKm: 40, priceSameDay: 391 },
  { fromSlug: "hilleroed", toSlug: "koebenhavn", approxKm: 40, priceSameDay: 391 },
  { fromSlug: "koebenhavn", toSlug: "naestved", approxKm: 88, priceSameDay: 679 },
  { fromSlug: "roskilde", toSlug: "koege", approxKm: 25, priceSameDay: 301 },
  // NEW 12 routes covering the new cities
  { fromSlug: "koebenhavn", toSlug: "slagelse", approxKm: 90, priceSameDay: 691 },
  { fromSlug: "slagelse", toSlug: "koebenhavn", approxKm: 90, priceSameDay: 691 },
  { fromSlug: "koebenhavn", toSlug: "holbaek", approxKm: 65, priceSameDay: 541 },
  { fromSlug: "holbaek", toSlug: "koebenhavn", approxKm: 65, priceSameDay: 541 },
  { fromSlug: "koebenhavn", toSlug: "ringsted", approxKm: 65, priceSameDay: 541 },
  { fromSlug: "koebenhavn", toSlug: "frederikssund", approxKm: 40, priceSameDay: 391 },
  { fromSlug: "frederikssund", toSlug: "koebenhavn", approxKm: 40, priceSameDay: 391 },
  { fromSlug: "roskilde", toSlug: "holbaek", approxKm: 35, priceSameDay: 361 },
  { fromSlug: "roskilde", toSlug: "ringsted", approxKm: 30, priceSameDay: 331 },
  { fromSlug: "naestved", toSlug: "koebenhavn", approxKm: 88, priceSameDay: 679 },
  { fromSlug: "hilleroed", toSlug: "helsingoer", approxKm: 25, priceSameDay: 301 },
  { fromSlug: "slagelse", toSlug: "naestved", approxKm: 30, priceSameDay: 331 },
];

export const ROUTE_SLUG = (fromSlug, toSlug) => `/fra-${fromSlug}-til-${toSlug}`;
